import { colors } from '@airwallex/global';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * ↓↓↓ deprecated tokens for timeline, kept for compatibility ↓↓↓
 */
var state = {
  default: colors.greys[40],
  success: colors.greens[70],
  informational: colors.greys[70],
  warning: colors.oranges[70],
  critical: colors.reds[70],
  active: colors.ultraViolets[70]
};
var start = "" + state.success + " 100%";
var v = {
  success: "linear-gradient(0deg, " + state.success + " 20%, " + start + ")",
  error: "linear-gradient(0deg, " + state.critical + " 20%, " + start + ")",
  active: "linear-gradient(0deg, " + state.active + " 20%, " + start + ")"
};
var h = {
  success: "linear-gradient(-90deg, " + state.success + " 40%, " + start + ")",
  error: "linear-gradient(-90deg, " + state.critical + " 40%, " + start + ")",
  active: "linear-gradient(-90deg, " + state.active + " 40%, " + start + ")"
};
var timelineThemeLegacy = {
  color: {
    default: state.default,
    success: state.success,
    informational: state.informational,
    warning: state.warning,
    critical: state.critical,
    active: state.active
  },
  connector: {
    horizontal: {
      completed: "" + h.success,
      current: "" + h.active,
      review: "" + h.active,
      rejected: "" + h.error
    },
    vertical: {
      completed: "" + v.success,
      current: "" + v.active,
      review: "" + v.active,
      rejected: "" + v.error
    }
  }
};
/**
 * ↑↑↑ deprecated tokens for timeline, kept for compatibility ↑↑↑
 */
var getTimelineTheme = theme => {
  return _extends({}, timelineThemeLegacy, {
    colors: {
      state: {
        initial: theme.colors.greys[40],
        success: theme.colors.greens[70],
        informational: theme.colors.greys[70],
        warning: theme.colors.oranges[70],
        critical: theme.colors.reds[70],
        active: theme.colors.ultraViolets[70]
      }
    }
  });
};
export { getTimelineTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
